import { render } from "./TaskEditComment.vue?vue&type=template&id=08e03af7&scoped=true"
import script from "./TaskEditComment.vue?vue&type=script&lang=js"
export * from "./TaskEditComment.vue?vue&type=script&lang=js"

import "./TaskEditComment.vue?vue&type=style&index=0&id=08e03af7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e03af7"]])

export default __exports__